import React from 'react';
import { URL, TYPE, ACTION } from "./URL";
import { OfflineScanner } from "./OfflineScanner";


const Offscan = () => {
  const data = {
    id: 1,
    name: "オフライン",
  };
  const action = ACTION.OUTBOUND;
  return <OfflineScanner storage={data} url={new URL(action)} />;
};


export default Offscan;
